import { withStyles } from '@material-ui/core';
import WithDrawer from '../../../Dispatch/Common/Drawer/WithDrawer';
import Banner from './Banner';
import SummaryDetails from './SummaryDetails';
const styles = (theme) => ({
  paperAnchor: {
    position: 'fixed',
    top: 54,
    padding: 0,
    borderLeft: `1px solid ${theme.AppBGColor}`,
    boxShadow: 'none',
    width: '100%',
    height: 'calc(100% - 60px)',
    boxSizing: 'border-box',
    backgroundColor: theme.gridBGColor,
    // Above Dynamic Routing Dialog (MUI default ~1300) so Create Routes stays on top until the user clicks it
    zIndex: 1400,
    transform: 'translate(0px, 0px)',
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  paperHidden: {
    height: 0,
    width: 0
  },
  backdrop: {
    position: 'absolute',
    backgroundColor: 'transparent'
  },
  modal: {
    position: 'absolute',
    zIndex: 1400
  }
});
const Summary = WithDrawer(({ etlSummaryDetails, handleClose }) => (
  <>
    <Banner />
    <SummaryDetails etlSummary={etlSummaryDetails} onCloseSummary={handleClose} />
  </>
));

const SummaryOverlay = ({ classes, open, ...rest }) => {
  return (
    <Summary
      open={open}
      anchor="bottom"
      variant="persistent"
      drawerClasses={{
        paper: `${classes.paperAnchor} customScroll ${!open ? classes.paperHidden : ''}`,
        modal: classes.modal
      }}
      BackdropProps={{
        className: classes.backdrop
      }}
      {...rest}
    />
  );
};

export default withStyles(styles)(SummaryOverlay);
